export const groupsUrl = 'groups/';
export const groupUrl = (groupId: string) => `groups/${groupId}/`;
